import axios, { AxiosInstance } from "axios";
import { urlConfig } from "../config";

let axiosInstance: AxiosInstance;

const setupAxiosInstance = (data:  any | null) => {
  if (!axiosInstance) {
    axiosInstance = axios.create({
      baseURL: urlConfig.BASE_URL,
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": urlConfig.SUBSCRIPTION_KEY,
        "X-PYC-UserName": data
          ? `${data?.given_name} ${data?.family_name}`
          : "System.Marketplace",
        "X-PYC-UserURN": data
          ? `${data?.extension_UserURN}`
          : "System.Marketplace",
      },
    });
  }

  return axiosInstance;
};

export const getAxiosInstance = () => {
  let clientDetails:  any | string | null =
    typeof window !== "undefined" ? localStorage.getItem("client") : null;
  clientDetails = clientDetails
    ? (JSON.parse(clientDetails) as any)
    : null;

  return setupAxiosInstance(clientDetails);
};
